module.exports = __webpack_public_path__ + "c86bc80e100f82121f95b2baf5bdfc14.jpg";